import Mpc from './mpc';
import aes from './lib/aes';
const mpc = new Mpc();
export { mpc, aes };
export * from './type';
//# sourceMappingURL=index.js.map